import {
  OLD_PLACEHOLDER_BUSINESS_CODE,
  OLD_PLACEHOLDER_CUSTOMER_CONTACT,
  OLD_PLACEHOLDER_CUSTOMER_NAME,
  OLD_PLACEHOLDER_ORDER_NO,
  OLD_PLACEHOLDER_ORDER_TOTAL_UNIT,
  OLD_PLACEHOLDER_PACKAGE_INDEX,
  OLD_PLACEHOLDER_TOTAL_PACKAGE,
} from "./constants/label.js";
import { toPackQR } from "./qrcode.js";
import renderLabelContent from "./renderLabelContent.js";

export default function (pack, context, settings) {
  const {
    packTitle = `@${OLD_PLACEHOLDER_BUSINESS_CODE}\r\n@${OLD_PLACEHOLDER_ORDER_NO}`,
    packContent = `@${OLD_PLACEHOLDER_CUSTOMER_NAME}\r\n@${OLD_PLACEHOLDER_CUSTOMER_CONTACT}`,
    packAppendix = `@${OLD_PLACEHOLDER_PACKAGE_INDEX}/@${OLD_PLACEHOLDER_TOTAL_PACKAGE}\r\n@${OLD_PLACEHOLDER_ORDER_TOTAL_UNIT}`,
  } = settings || {};

  return {
    qrcode: toPackQR(pack?.id),
    title: packTitle ? renderLabelContent(packTitle, pack, context) : ``,
    content: packContent ? renderLabelContent(packContent, pack, context) : ``,
    appendix: packAppendix ? renderLabelContent(packAppendix, pack, context) : ``,
    homeDelivery: pack?.homeDelivery,
  };
}
